import { AuthEffects } from './auth.effects';
import { SettingsEffects } from './settings.effects';

export const Effects = [AuthEffects, SettingsEffects];
